// extracted by mini-css-extract-plugin
module.exports = {"container":"notification_watcher_count-module__container--L7xMD"};